var map = {
	"./banner.svg": 417,
	"./crud.svg": 418,
	"./features.svg": 419,
	"./gallery.svg": 420,
	"./gen.svg": 421,
	"./icons.svg": 422,
	"./navigation.svg": 423,
	"./partners.svg": 424,
	"./paymentMethods.svg": 425,
	"./search.svg": 426,
	"./social.svg": 427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 416;